<template>
  <v-form ref="form" class="">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>      

      <v-col cols="12" sm="12">
        <v-text-field
          v-model="entry.name"
          v-bind="getObject('name')"
          label="Nome"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>      

      <v-col cols="12">
        <v-textarea
          v-model="entry.description"
          v-bind="getObject('description')"
          label="Descrição"
          autocomplete="off"
          outlined
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" v-if="peopleList.length > 0 && showNesteds">
        <MultiSelect
          v-model="entry.personIdsAttribute"
          v-bind="getObject('personIdsAttribute')"
          label="Cliente(s)"
          :items="peopleList"
          :loadingItems="peopleListLoading"                    
          :readOnly="readOnly"
        >          
        </MultiSelect>
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import BaseUtil from "@shared_components/base_util.vue";
import MultiSelect from "@shared_components/multi_select.vue";
import gql from 'graphql-tag';

export default {
  data() {
    return {
      entryAttributes: {},
      pageLoading: false,
      peopleList: [],
      peopleListLoading: false,      
      peopleErrors: []
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    showNesteds: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
    MultiSelect: MultiSelect,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    this.selectClients(false, true);
  },
  mounted() {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    selectClients: function(cleanClient=false, verifyClientsOnLoad=false) {
        this.peopleListLoading = true;
        this.$apollo
          .query({
            query: LOAD_ALL_CLIENTS_FOR_ROUTES_QUERY,
            fetchPolicy: "no-cache",            
          })
          .then(response => {
            // console.log("response dos all periods", response)
            this.peopleList = response.data.accountContext.allCustomers;

            if (cleanClient) {
              this.entry.personIdsAttribute = [];
            }

            if (verifyClientsOnLoad) {
              this.peopleList
              if (this.entry.people && this.entry.people.length > 0) {
                for(let person in this.entry.people) {
                  if (!this.peopleList.some(peopleList => peopleList.id == this.entry.people[person].id)) {
                    this.peopleList.push(this.entry.people[person]);
                    // console.log("person adicionado ", this.entry.periods[person]);
                  }
                }
              }
            }

            if (this.entry.personIdsAttribute.length == 0 && this.peopleList.length == 1) {
              this.entry.personIdsAttribute = [this.peopleList[0].id];
            }
            if (this.entry.personIdsAttribute.length > 0) {
              this.selectPerson();
            }
          })
          .catch(response => console.log(response))
          .finally(() => (this.peopleListLoading = false));          
    },
    selectPerson: function() {
      this.entry.people = [];
      let notInList = [];
      this.peopleErrors = [];
      for(let index in this.entry.personIdsAttribute) {
        let person = this.peopleList.find(obj => obj.id == this.entry.personIdsAttribute[index])
        if (person) {
          this.entry.people.push(person);
        } else {
          notInList.push(this.entry.personIdsAttribute[index]);
          this.entry.personIdsAttribute.splice(index, 1);
        }
      }
      // console.log("notInList", notInList);
    },
  }
};

const LOAD_ALL_CLIENTS_FOR_ROUTES_QUERY = gql`
query {
	accountContext {
    allCustomers{
      id
      name
    }
  }
}`;

</script>

<style scoped></style>
